<template>
	<div class="chainmap" id="chainmapBox">
		<div class="echartBox" id="chain_map_provience" :style="'width:'+mapboxWidth+'px;height:'+mapboxHeight+'px;'"></div>
		<div id="chain_map_city" v-show="allowProvinceClick"></div><!--v-show="!indexmapflag && !nosonCity"-->
	</div>
</template>

<script>
import $ from "jquery";
import { cityMap } from "../../assets/js/citymap.js";
export default {
	name: 'chainMap',
	data() {
		return {
			islogin: false,
			colorsarry: { bgcolor: "#fff", blue: "", dblue: "", epcolor: "#ff0", bdcolor: "#fff" },
		}
	},
	props: {
		leftNumber: { //地图左边距离
			default: '50%',
			type: String,
		},
		mapdata: {
			type: Array, required: true, 
		},
		citymapflag: {
			default: false,
			type: Boolean
		},
		indexmapflag: {
			default: false,
			type: Boolean
		},
		allowProvinceClick: {
			default: false,
			type: Boolean
		},
		title:{
			default: '',
			type: String
		},
		mapUnit:{
			default: '家公司',
			type: String
		},
		mapboxWidth:{
			default: 1166,
			type: Number
		},
		mapboxHeight:{
			default: 600,
			type: Number
		}
	},
	watch: {
		mapdata: {
			handler(newValue, oldValue) {
				this.type = newValue;
				this.initchartfun();
			}
		},
	},
	mounted() {
		var chart = echarts.init(document.getElementById('chain_map_provience'));
		chart.showLoading({
			text: 'loading',
			color: '#3A568E',
			textColor: '#000',
			maskColor: 'rgba(255, 255, 255, 1)',
			zlevel: 1,
		});
		var chartcity = echarts.init(document.getElementById('chain_map_city'));
		// eval("var _data = " + $('#chain_map_provience').attr("data"));
		// console.log(this.mapdata);
		var _data = this.mapdata;
		var citydata = '';
		var _this = this;
		var option = this.getoptiondata();
		//34个省、市、自治区的名字拼音映射数组
		var provinces = {
			//23个省
			"台湾": "taiwan",
			"河北": "hebei",
			"山西": "shanxi",
			"辽宁": "liaoning",
			"吉林": "jilin",
			"黑龙江": "heilongjiang",
			"江苏": "jiangsu",
			"浙江": "zhejiang",
			"安徽": "anhui",
			"福建": "fujian",
			"江西": "jiangxi",
			"山东": "shandong",
			"河南": "henan",
			"湖北": "hubei",
			"湖南": "hunan",
			"广东": "guangdong",
			"海南": "hainan",
			"四川": "sichuan",
			"贵州": "guizhou",
			"云南": "yunnan",
			"陕西": "shanxi1",
			"甘肃": "gansu",
			"青海": "qinghai",
			//5个自治区
			"新疆": "xinjiang",
			"广西": "guangxi",
			"内蒙古": "neimenggu",
			"宁夏": "ningxia",
			"西藏": "xizang",
			//4个直辖市
			"北京": "beijing",
			"天津": "tianjin",
			"上海": "shanghai",
			"重庆": "chongqing",
			//2个特别行政区
			"香港": "xianggang",
			"澳门": "aomen"
		};

		//直辖市和特别行政区-只有二级地图，没有三级地图
		var special = ["北京", "天津", "上海", "重庆", "香港", "澳门"];
		var mapdata = [];
		//绘制全国地图
		$.getJSON('/map/china.json', function (data) {
			var d = [];
			for (var i = 0; i < data.features.length; i++) {
				d.push({
					name: data.features[i].properties.name
				})
			}
			mapdata = d;
			//注册地图
			echarts.registerMap('china', data);
			//绘制地图
			_this.renderMap('china', _data, "", option);
			//	renderMap('china', d);
		});

		//地图点击事件
		chart.on('click', function (params) {
			console.log(params);
			if(!_this.allowProvinceClick){
				return;
			}
			if (_this.citymapflag && params.data != undefined) {
				_this.$emit('chartmapclick', params.data);
			}
			if (params.name in provinces) {
				// console.log(params.name in provinces);
				//如果点击的是34个省、市、自治区，绘制选中地区的二级地图
				$.getJSON('/map/province/' + provinces[params.name] + '.json', function (data) {
					console.log('选中的地图', data, params);
					for (var i = 0; i < _data.length; i++) {
						var dataname = _data[i].name;
						if (dataname == params.name) {
							citydata = _data[i].data;
						}
					}
					echarts.registerMap(params.name, data);
					var d = [];
					for (var i = 0; i < data.features.length; i++) {
						d.push({
							name: data.features[i].properties.name
						})
					}
					// console.log(0,params.data.data,citydata,_data);
					_this.renderMap(params.name, params.data.data, 'c', option);
					//			renderMap(params.name, d, 'c');
				});
			} else if (params.seriesName in provinces) {
				//如果是【直辖市/特别行政区】只有二级下钻
				if (special.indexOf(params.seriesName) >= 0) {
					console.log(1);
					_this.renderMap('china', mapdata, 'c', option);
				} else {
					//显示县级地图
					$.getJSON('../../assets/js/map/city/' + cityMap[params.name] + '.json', function (data) {
						echarts.registerMap(params.name, data);
						var d = [];
						for (var i = 0; i < data.features.length; i++) {
							d.push({
								name: data.features[i].properties.name
							})
						}
						console.log(2);
						_this.renderMap(params.name, d, 'c', option);
					});
				}
			} else {
				console.log(3);
				this.renderMap('china', mapdata, 'c', option);
			}
		});
		//小地图点击事件
		chartcity.on('click', function (params) {
			if (_this.citymapflag && params.data != undefined) {
				_this.$emit('chartmapclick', params.data);
			}
		});

	},
	created() {
		if (this.indexmapflag) {
			this.colorsarry = { bgcolor: "#19213c", blue: "", dblue: "", epcolor: "#ffbb1c", bdcolor: "#19213c" };
		}

	},
	methods: {
		getoptiondata() {
			//初始化绘制全国地图配置 
			var mapUnit=this.mapUnit;
			var options4 = {
				backgroundColor: this.colorsarry.bgcolor,
				title: { text: this.title,  left: 80, 	top:20, textStyle: { color: '#666', fontSize: 18, fontWeight: 700, fontFamily: "Microsoft YaHei" },  }, 
				tooltip: {
					trigger: 'item',
					backgroundColor: 'rgba(255,255,255,0.7)',
					borderColor: '#ddd',
					borderWidth: '1',
					padding: 0,
					textStyle: {
						color: '#333',
					},
					formatter: function (b, c) {
						var vals = b.value;
						var names = b.name;
						if (vals > 0 && vals != NaN) {
							return '<div class="map-tooltip"><h5>' + names + '：</h5><p class="bluepoint">' + vals + mapUnit+'</p></div>'
						} else {
							return "";
						}
					}
				},
				toolbox: {
					show: false,
					orient: 'vertical',
					left: 'right',
					top: 'center',
					feature: {
						dataView: {
							readOnly: false
						},
						restore: {},
						saveAsImage: {}
					},
					iconStyle: {
						normal: {
							color: '#333'
						}
					}
				},
				animationDuration: 1000,
				animationEasing: 'cubicOut',
				animationDurationUpdate: 1000
			};
			return options4;
		},
		initchartfun() {
			var _this = this;
			var _data = this.mapdata;
			var mapdata = [];
			//初始化绘制全国地图配置
			var option = this.getoptiondata();

			$.getJSON('/map/china.json', function (data) {
				var d = [];
				for (var i = 0; i < data.features.length; i++) {
					d.push({
						name: data.features[i].properties.name
					})
				}
				mapdata = d;
				//注册地图
				echarts.registerMap('china', data);
				//绘制地图
				_this.renderMap('china', _data, "", option);
				//	renderMap('china', d);
			});
		},
		renderMap(map, data, type, option) {
			let _this = this;
			const chart = echarts.init(document.getElementById('chain_map_provience'));
			const chartcity = echarts.init(document.getElementById('chain_map_city'));
			var minnum = 0, maxnum = 10;
			for (var i = 0; i < data.length; i++) {
				var value1 = data[i].value + 10;
				maxnum = maxnum > value1 ? maxnum : value1;
			}
			var hovercolor = ['#c7ddf7', '#3887e1'];
			if (this.indexmapflag) {
				hovercolor = ["#5fa4d9", "#0f436b"];
			}
			option.visualMap = {
				show: type != 'c',
				left: 0,
				bottom: 40,
				min: minnum,
				max: maxnum,
				text: ['高', '低'],
				realtime: false,
				itemHeight: 100,
				orient: 'horizontal',
				calculable: false,
				show: false,
				inRange: {
					color: hovercolor,
				}
			};
			option.series = [{
				name: map,
				type: 'map',
				mapType: map,
				// left:_this.leftNumber.left,
				layoutCenter: [this.leftNumber, '50%'],
				layoutSize:'100%',
				roam: false,
				nameMap: {
					'china': '中国'
				},
				label: {
					normal: {
						show: type != 'c',
						textStyle: {
							color: '#333',
							fontSize: 10
						}
					},
					emphasis: {
						show: true,
						textStyle: {
							color: '#333',
							fontSize: 10
						}
					}
				},
				itemStyle: {
					normal: {
						areaColor: '#ddd',
						borderColor: this.colorsarry.bdcolor
					},
					emphasis: {
						areaColor: this.colorsarry.epcolor
					}
				},
				data: data
			}];
			//渲染地图
			if (type == 'c') {
				//可以点击省市一级
				// chartcity.clear(); 

				chartcity.hideLoading();
				chartcity.setOption(option, true);
			} else {
				if (this.indexmapflag || this.mapboxWidth>1166) {
					option.series[0].center = [105.87, 35];
					option.series[0].zoom = 1.2;
				} else {
					option.series[0].center = [118.97, 35];
					option.series[0].zoom = 1.1;
				}
				//		option.series[0].data=_data;

				var timer = setTimeout(function () {
					chart.hideLoading();
					chart.setOption(option, true);
				}, 1500)

			}
		}
	}
}
</script>

<style></style>
